var _radialGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInspire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-inspire",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 199.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Inspire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "InspireIconGradient",
    cx: 0.25,
    cy: 0.25,
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00a0ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#044e77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#InspireIconGradient)",
    d: "M81.59,157.41A479.6,479.6,0,0,1,49.86,50.93,475.41,475.41,0,0,1,167.47,77.39a484,484,0,0,1-85.88,80M53,188.27a99.27,99.27,0,0,0,39.7,11.48L79.42,170.91A221.58,221.58,0,0,1,53,188.26M100,0A99.58,99.58,0,0,0,44.52,16.82l.07.09,3.18,24.63A474.32,474.32,0,0,1,172.88,70.29L186.65,50A100,100,0,0,0,100,0M40.87,19.42a100.73,100.73,0,0,0-21.15,21h.08s21.57.29,23.28.74L40.9,19.47ZM196.13,80.85h0l2.12,1h.1a99.57,99.57,0,0,0-7.21-23.16,90.86,90.86,0,0,1-9.91,15l10.3,4.94,4.6,2.2m3.44,9.94L191.27,87l-15.12-6.79a457.69,457.69,0,0,1-90.62,86.52l13.23,26.87.08.14,3,6.13h0V200A100,100,0,0,0,200,100c0-3.12-.2-6.18-.48-9.21M42,181.46h0l3.1-1.65c5.4-2.9,17.17-9.45,30.34-18.33A549.06,549.06,0,0,1,44.52,51S15,49.65,13.07,50.66a100,100,0,0,0,28.87,130.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInspire);
export default __webpack_public_path__ + "static/media/icon-inspire.539d129873583dfc8db44d37c6dca73f.svg";
export { ForwardRef as ReactComponent };